/* little charlie result pages, on Bathorium's store. Written by
   assemble-the-result-theme-files.py from the page the results builder writes.
   The result and the market come off the address when it carries them, else
   from the template (window.LC_RESULT). Do not edit here: edit the builder. */
(function(){
"use strict";
var touched=false;
['wheel','touchstart','keydown','click'].forEach(function(ev){
  window.addEventListener(ev,function(){touched=true},{passive:true,once:true})});
function toTop(){if(!touched&&!location.hash) window.scrollTo(0,0)}
toTop();
window.addEventListener('load',toTop);
setTimeout(toTop,120); setTimeout(toTop,400);
var D=JSON.parse(document.getElementById('payload').textContent);
var $=function(i){return document.getElementById(i)};
var money=function(n){return '$'+n.toFixed(2).replace(/\.00$/,'')};
var esc=function(s){return String(s).replace(/[&<>"]/g,function(c){
  return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})};
var R=null,sizeIdx=0,picked={},STEPS=[],openStep=1;
var MKT=null,M=null;
/* THE RESULT COPY SHIPS ONCE, so rebuild the other market before anything reads
   it. Both markets carry the same five results and differ in 59 values out of
   63 KB each: the prices, the was-prices, the per-bath figures, two variant
   numbers, the American bundle's own photographs and two answers that quote
   money. Shipping all of it twice was a third of the page, and it was the reason
   the finished page was too big to put on a link anybody could open.

   This is not a guess and it is not a fallback. The builder rebuilds each market
   from this exact diff in Python and refuses to write the page unless the rebuild
   matches, byte for byte, the market it computed off that market's own Shopify
   record. So by the time this runs, the answer is already proven. */
(function(){
  var base={};
  for(var b in D.markets) if(D.markets[b].results) base[b]=D.markets[b].results;
  for(var m in D.markets){
    var mk=D.markets[m], results;
    if(mk.resultsFrom){
      results=JSON.parse(JSON.stringify(base[mk.resultsFrom]));
      var byKey={};
      for(var i=0;i<results.length;i++) byKey[results[i].key]=results[i];
      for(var j=0;j<mk.resultsDiff.length;j++){
        var d=mk.resultsDiff[j], node=byKey[d[0]], path=d[1];
        for(var k=0;k<path.length-1;k++) node=node[path[k]];
        node[path[path.length-1]]=d[2];
      }
    } else {
      results=JSON.parse(JSON.stringify(mk.results));
    }
    /* Whatever is the same on all five of this market's result pages was written
       once for the market. The seven ingredients and the whole answer list are
       identical on every one of them, and they were shipping five times each. */
    if(mk.sharedResult){
      for(var sk in mk.sharedResult){
        for(var r=0;r<results.length;r++)
          results[r][sk]=JSON.parse(JSON.stringify(mk.sharedResult[sk]));
      }
    }
    mk.results=results;
    delete mk.resultsFrom; delete mk.resultsDiff; delete mk.sharedResult;
  }
})();
function knownMarket(v){
  v=String(v==null?'':v).toLowerCase().trim();
  return D.markets[v]?v:null;
}
/* `market` is the one we publish. `country` is accepted as well, because an ad
   platform or a link somebody hand edits is far more likely to reach for that
   word, and silently serving Canadian prices to a link that plainly said US
   would be the worst possible failure here. Anything unrecognised falls back to
   Canada rather than to an error. */
function marketFromLink(){
  var q=new URLSearchParams(location.search);
  return knownMarket(q.get('market'))||knownMarket(q.get('country'))||knownMarket(window.LC_RESULT&&window.LC_RESULT.market)||D.defaultMarket;
}
function setMarket(m){MKT=m;M=D.markets[m]}
setMarket(marketFromLink());
function ico(k){return D.icons[k]||D.icons.leaf}
function botIcon(n){return (D.botMap||{})[n]||'leaf'}

$('logo').src=D.logo;
$('trust').innerHTML=(function(){
  var one=D.trust.map(function(x){
    return '<span class="cell">'+ico(x.i)+x.t+'</span>'}).join('');
  return one+one+one})();
$('credit').textContent=D.press.heading;
$('creditsub').textContent=D.press.line;

function render(key,name){
  R=M.results.filter(function(r){return r.key===key})[0]||M.results[0];
  var poss=name?name+"'s":'Their';
  $('kitTitle').textContent=poss+' profile: The '+R.kit;
  $('oneliner').textContent=R.oneliner.replace(/\{Their\}/g,poss);
  $('studyline').textContent=D.studyLabel;
  sizeIdx=R.choice?R.choice.default:0;
  picked={};
  R.core.forEach(function(b){picked[b.name]=true});
  if(R.choice) R.choice.items.forEach(function(o){picked[o.name]=true});
  /* Every STEP of the ritual arrives in the basket, which is how both the
     other two funnels work. The tier on top starts UNTICKED: that is the
     client's own toggle-to-add rule, and the difference between a step and
     something slipped in. Any step can come out in one tap. */
  R.optional.forEach(function(x){picked[x.name]=false});
  buildSteps();
  $('ruleTop').innerHTML=ico('tub');
  $('servings').textContent=D.servings;
  /* Under the headline number: the before-and-after pairs from the client's
     own 30-day study, the same carousel the landing page carries (Allan,
     2026-09-03). It moves on its own every few seconds, holds still under a
     finger or a pointer, and the arrows work on a desktop. */
  $('servings').textContent=R.headline;
  $('wallsec').style.display=D.beforeAfter.pairs.length?'':'none';
  $('wall').innerHTML=D.beforeAfter.pairs.map(function(pr){
    return '<figure class="wcard pair">'+
      '<span><img src="'+D.beforeAfter.base+pr[0]+'" alt="'+esc(D.beforeAfter.before)+'" loading="lazy"><i>'+esc(D.beforeAfter.before)+'</i></span>'+
      '<span><img src="'+D.beforeAfter.base+pr[1]+'" alt="'+esc(D.beforeAfter.after)+'" loading="lazy"><i class="after">'+esc(D.beforeAfter.after)+'</i></span>'+
      '</figure>'}).join('');
  (function(){
    var w=$('wall'), timer;
    function next(){ var max=w.scrollWidth-w.clientWidth-2;
      if(w.scrollLeft>=max){ w.scrollTo({left:0,behavior:'smooth'}); } else { wscroll(1); } }
    function start(){ timer=setInterval(next,3500); }
    function hold(){ clearInterval(timer); start(); }
    w.addEventListener('pointerdown',function(){clearInterval(timer)});
    w.addEventListener('pointerup',hold);
    w.addEventListener('mouseenter',function(){clearInterval(timer)});
    w.addEventListener('mouseleave',hold);
    start();
    var cap=document.createElement('p'); cap.className='wallcap';
    cap.textContent=D.beforeAfter.caption;
    $('wallsec').querySelector('.wallwrap').insertAdjacentElement('afterend',cap);
  })();

  $('faq').innerHTML=R.faq.map(function(f){
    return '<details><summary>'+esc(f.q)+'</summary><div class="ans">'+esc(f.a)+
           '</div></details>'}).join('');
  $('worktogether').textContent='Chosen from your answers. Take out anything you do not want.';

  /* The answers mirror. Built from the web address, never from a guess, and
     the whole block hides itself when there is nothing real to repeat back.
     Landing on the July page with no answers still said "You told us: pink or
     red, scratching at night" and quoted a spend figure. Nobody had said either. */
  (function(){
    var q=new URLSearchParams(location.search), rows=[];
    var seen=(q.get('q3')||'').split(',').map(function(s){return s.trim()})
                              .filter(function(s){return s});
    seen.slice(0,2).forEach(function(k){ if(D.answers.q3[k]) rows.push(D.answers.q3[k]) });
    var after=q.get('q6');
    if(after&&D.answers.q6[after]) rows.push(D.answers.q6[after]);
    var spend=q.get('q5');
    if(spend&&D.answers.q5[spend])
      rows.push([D.answers.q5[spend],D.answers.spendIcon,M.spendLine]);
    var age=q.get('q2');
    if(age&&D.answers.q2[age])
      rows.push([D.answers.q2[age],D.answers.ageIcon,D.answers.ageLine]);
    rows=rows.slice(0,3);

    if(!rows.length){ $('mirror').style.display='none'; return }
    $('mirror').style.display='';
    $('concerns').innerHTML=rows.map(function(c){
      return '<div class="rw"><b>'+esc(c[0])+'</b>'+
        '<p><span class="bot">'+ico(D.icoFor[c[1]]||'leaf')+esc(c[1])+'</span><br>'+
        esc(c[2])+'</p></div>'}).join('');

    /* One extra line, and only for the two skin profiles, and only when they
       actually agreed they had lost count of the creams. */
    if(q.get('q4')==='agree'&&D.creamsProfiles.indexOf(R.key)>=0){
      $('concerns').innerHTML+='<div class="rw"><b></b><p><b>'+esc(D.creamsLine)+'</b></p></div>';
    }
  })();

  // the ritual: one card per product, with when to use it
  /* The product write-up section is gone (Allan, 2026-09-03), so the size
     tap's repaint has nothing to draw. Kept as a no-op because recalc() calls it. */
  render.paintGallery=function(){};
  /* The review wall's heading. Its two earlier writers both sat inside spans
     that later swaps replace, so the live pages shipped with an empty h2 over
     the reviews from 20/08 to 03/09. Written here, after the last of them. */
  $('revhead').textContent="What other parents say";

  $('ings').innerHTML=R.ingredients.map(function(g){
    return '<article class="ing'+(g.p?' photo':'')+'">'+(g.p?'<img class="ingpic" src="'+g.p+'" alt="'+esc(g.n)+'" loading="lazy">':'<span class="ring">'+ico(g.i)+'</span>')+
      '<b>'+esc(g.n)+'</b><p>'+esc(g.s)+'</p>'+
      '<div class="chips">'+g.c.map(function(c){
        return '<span>'+esc(c)+'</span>'}).join('')+'</div></article>'}).join('');
  wireIngredients(); wireGalleries();

  /* Quoted word for word, typos included, attributed by the real review DATE
     and where it was left. No reviewer names, and no stars: the client says
     that format reads weak, and inventing a name on somebody's review is not on.
     Every review that names a skin condition is out, however good it is. */
  $('revlist').innerHTML=R.reviews.slice(0,6).map(function(r){
    return '<article class="rev"><p>'+esc(r.c)+'</p>'+
      '<div class="who"><svg class="tick" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg>Verified review, '+esc(r.p)+', '+esc(r.n)+'</div></article>'}).join('');

  recalc();
}

function allItems(){
  var out=R.core.slice();
  if(R.choice) out.push(R.choice.items[sizeIdx]);
  return out.concat(R.optional).sort(function(a,b){return a.pos-b.pos});
}
function chosen(){
  return allItems().filter(function(i){return picked[i.name]});
}
function recalc(){
  var items=chosen();
  var total=items.reduce(function(a,b){return a+b.price},0);
  var wasTotal=items.reduce(function(a,b){return a+(b.was||b.price)},0);
  var saving=wasTotal-total;

  $('plist').innerHTML=items.map(function(i){
    return '<li><span>'+esc(i.title)+'<small>'+esc(i.fn)+'</small></span><b>'+
           money(i.price)+'</b></li>'}).join('');
  /* The one line the sticky bar carries, in the panel too: "5 items, $88,
     save $10". Without it the desktop panel was a heading, a total, a button
     and dead space (Allan's 03/09 critique). Written once, below, into both. */

  /* The size taps. Cost per bath rides beside the price, because price is by far
     the loudest objection on every little charlie ad, and it is the SOAK ONLY:
     the Gift Set and the Bundle carry no per-bath figure because nobody can read
     the soak size printed inside them. */
  if(R.choice){
    $('sizes').innerHTML=R.choice.items.map(function(o,k){
      return '<div class="opt size'+(k===sizeIdx?' on':'')+'" data-size="'+k+'">'+
        '<span class="dot"></span><span><b>'+esc(o.sizeLabel)+'</b>'+
        '<small>'+esc(o.sizeNote)+'</small></span>'+
        '<span class="pr"><b>'+money(o.price)+'</b>'+
        (o.perBath?'<i class="per">'+o.perBath+'</i>':'')+
        (o.was?'<s>'+money(o.was)+'</s>':'')+
        '</span></div>'}).join('');
    Array.prototype.forEach.call($('sizes').querySelectorAll('[data-size]'),function(el){
      el.addEventListener('click',function(){
        var was=R.choice.items[sizeIdx];
        sizeIdx=+el.getAttribute('data-size');
        picked[R.choice.items[sizeIdx].name]=picked[was.name];
        paintSteps(); render.paintGallery(); recalc()})});
    $('sizelbl').textContent=R.choice.title;
    $('sizes').style.display=''; $('sizelbl').style.display='';
  } else {
    $('sizes').innerHTML=''; $('sizes').style.display='none';
    $('sizelbl').textContent=''; $('sizelbl').style.display='none';
  }

  $('curline').innerHTML='<span class="curnow">'+esc(M.currencyLine)+'</span>'+
    '<span class="curset">'+Object.keys(D.markets).map(function(m){
      var on=m===MKT;
      return '<button type="button" class="curbtn'+(on?' on':'')+'" data-market="'+m+
        '" aria-pressed="'+on+'" aria-label="'+esc(D.markets[m].switchAria)+'">'+
        esc(D.markets[m].switchLabel)+'</button>'}).join('')+'</span>';
  Array.prototype.forEach.call($('curline').querySelectorAll('[data-market]'),
    function(b){b.addEventListener('click',function(){
      switchMarket(b.getAttribute('data-market'))})});

  $('onetimeNote').textContent=D.discount?D.discount.line:'';

  /* Free shipping is LAST on purpose. It starts at $99 and most of these offers
     do not reach it, so it must never lead. */
  $('panelMarks').innerHTML=
    '<span class="mark">'+ico('shield-check')+esc(D.policy.guarantee)+'</span>'+
    '<span class="mark">'+ico('van')+esc(M.shipping)+'</span>';

  $('total').textContent=money(total);
  $('totlabel').textContent='Total today';

  paintSums();
  /* Nothing in the basket means nothing to buy. The cart address would be
     /cart/ with no items behind it, which lands on an empty Shopify cart and
     looks broken. */
  var empty=items.length===0, u=cartUrl();
  ['buy','endBuy','stickybtn'].forEach(function(id){
    var el=$(id); if(!el) return;
    el.textContent=empty?'Add something first':'Add to cart';
    el.href=empty?'#kit':u;
    el.classList.toggle('off',empty);
  });

  var n=items.length;
  var line=empty?'Nothing in the ritual yet'
    :'<b>'+n+' item'+(n===1?'':'s')+'</b> &middot; '+money(total)+
     (saving>0?' &middot; <em>save '+money(saving)+'</em>':'');
  $('stickynote').innerHTML=line;
  $('phint').innerHTML=line;
}
/* Moving currency re-prices the whole page: every card, every tap, the running
   total and the cart address. What it does NOT do is throw away what the reader
   has already chosen. The size they tapped and the add-ons they ticked are held
   across the switch and put back, because the product names are the same in both
   markets, and losing a ritual you had just built would be a worse answer than
   the wrong currency was.

   Scroll position is held too. A currency switch that jumps you back to the top
   of a long page reads as a page reload, and readers stop trusting the control. */
function switchMarket(m){
  if(!D.markets[m]||m===MKT) return;
  var keptPicked={},k;
  for(k in picked) if(Object.prototype.hasOwnProperty.call(picked,k))
    keptPicked[k]=picked[k];
  var keptSize=sizeIdx, y=window.pageYOffset;
  var key=R?R.key:M.results[0].key;
  var nm=(new URLSearchParams(location.search).get('name')||'').trim();
  setMarket(m);
  render(key,nm);
  /* render() has reset both, so put them back inside what this market actually
     offers. A market with fewer taps must never be left pointing past the end. */
  if(R.choice) sizeIdx=Math.max(0,Math.min(keptSize,R.choice.items.length-1));
  for(k in keptPicked) if(Object.prototype.hasOwnProperty.call(keptPicked,k) &&
      Object.prototype.hasOwnProperty.call(picked,k)) picked[k]=keptPicked[k];
  buildSteps();
  if(render.paintGallery) render.paintGallery();
  recalc();
  window.scrollTo(0,y);
}
function cartUrl(){
  var p=chosen().map(function(b){return b.vid+':1'});
  /* A real Shopify cart address. Tested against the live store in July: it lands
     on checkout, not the cart page, which is Shopify's own behaviour for this
     kind of link. */
  /* The country parameter is NOT optional and it is on BOTH markets,
     Canada included. Without it Shopify infers the market, and on 2026-08-18 the
     inference proved sticky per session: a bare link opened after a US link
     stayed on the US market and kept charging USD. With it, the live checkout
     moved to /en-us and priced the 250g soak at its USD figure of $18.00. */
  var q='?'+M.cartParam+(D.discount?'&discount='+D.discount.code:'');
  return D.shop+'/cart/'+p.join(',')+q;
}
/* The guided builder. Step one arrives already full, because the quiz chose.
   Bathorium's step one starts empty because you are composing from scratch. */
function buildSteps(){
  /* ONE step. Allan, 2026-09-03: "no add-ons. Whatever the recommendation is,
     and they can remove them." So the quiz's pick is the whole basket, every
     line arrives in with its own Remove button, and there is no second step
     underneath offering more. R.optional is empty on every page and is not
     drawn even if it were not. */
  STEPS=[{n:1,t:'What the quiz chose',
          r:'Based on your answers',
          items:R.choice?[R.choice.items[sizeIdx]].concat(R.core):R.core,
          kind:'core'}];
  openStep=1; paintSteps();
}
function stepSum(s){
  var on=s.items.filter(function(i){return picked[i.name]});
  if(!on.length) return 'Nothing added';
  return on.length+' added · '+money(on.reduce(function(a,i){return a+i.price},0));
}
function paintSums(){
  Array.prototype.forEach.call($('bsteps').querySelectorAll('.bstep'),function(el){
    var s=STEPS.filter(function(x){return x.n===+el.getAttribute('data-n')})[0];
    var e=el.querySelector('.sum'); if(s&&e) e.textContent=stepSum(s)});
}
function paintSteps(){
  if(STEPS.length) STEPS[0].items=R.choice
    ? [R.choice.items[sizeIdx]].concat(R.core) : R.core;
  $('bsteps').innerHTML=STEPS.map(function(s,idx){
    var open=s.n===openStep, done=s.n<openStep, last=idx===STEPS.length-1;
    return '<section class="bstep'+(open?' open':'')+(done?' done':'')+'" data-n="'+s.n+'">'+
      '<header data-open="'+s.n+'"><span class="circ">'+ico('tub')+'</span>'+
      '<span><h3>'+esc(s.t)+'</h3><p class="req">'+esc(s.r)+'</p>'+
      '<p class="sum">'+esc(stepSum(s))+'</p></span><span class="chev"></span></header>'+
      '<div class="body">'+s.items.map(function(i){return bitem(i)}).join('')+
      '<div class="bnext"><button data-done="'+s.n+'">'+
        (last?'Review the ritual':'Next')+'</button></div>'+
      '</div></section>'}).join('');

  Array.prototype.forEach.call($('bsteps').querySelectorAll('[data-add]'),function(b){
    b.addEventListener('click',function(){
      var n=b.getAttribute('data-add'); picked[n]=!picked[n];
      var row=b.closest('.bitem'); row.classList.toggle('on',picked[n]);
      b.textContent=picked[n]?'Remove':'Add'; recalc()})});
  Array.prototype.forEach.call($('bsteps').querySelectorAll('header[data-open]'),function(h){
    h.addEventListener('click',function(){
      var n=+h.getAttribute('data-open');
      openStep=(openStep===n)?0:n; paintSteps(); recalc()})});
  Array.prototype.forEach.call($('bsteps').querySelectorAll('[data-done]'),function(b){
    b.addEventListener('click',function(e){
      e.stopPropagation();
      var n=+b.getAttribute('data-done'), scroll=b.textContent.indexOf('Review')===0;
      openStep=n+1; paintSteps(); recalc();
      var target=scroll?document.querySelector('.panel'):$('bsteps').querySelector('.bstep.open');
      if(target) target.scrollIntoView({block:'center',behavior:'smooth'})})});
}
function bitem(i){
  var on=!!picked[i.name];
  var price=i.was?'<span class="p"><s>'+money(i.was)+'</s>'+money(i.price)+'</span>'
                 :'<span class="p">'+money(i.price)+'</span>';
  return '<div class="bitem'+(on?' on':'')+'">'+
    '<span class="thumbwrap"><img src="'+i.pack+'" alt="" loading="lazy"></span>'+
    '<span class="nm">'+esc(i.title)+'<em class="lw">'+esc(i.lineWhy||i.fn)+'</em>'+price+'</span>'+
    '<button data-add="'+esc(i.name)+'">'+(on?'Remove':'Add')+'</button></div>';
}
/* Gallery: she swipes or scrolls the strip sideways, or taps a thumbnail.
   No arrows on the picture, they sat on top of the product. The thumbnail
   outline follows whichever shot has settled in the frame. */
function wireGalleries(){
  Array.prototype.forEach.call(document.querySelectorAll('.step .pic'),function(pic){
    var frame=pic.querySelector('.frame');
    var imgs=pic.querySelectorAll('.frame img');
    var thumbs=pic.querySelectorAll('.thumb');
    if(!frame||imgs.length<2) return;
    var at=-1;
    function mark(n){
      if(n===at) return;
      at=n;
      Array.prototype.forEach.call(thumbs,function(b,k){b.classList.toggle('on',k===n)});
      var a=thumbs[n], strip=a&&a.parentElement;
      if(a&&strip&&strip.scrollWidth>strip.clientWidth){
        var to=a.offsetLeft-(strip.clientWidth-a.offsetWidth)/2;
        strip.scrollTo({left:Math.max(0,to),behavior:'smooth'});
      }
    }
    /* Two signals, both harmless if the other already fired: an observer for
       the shot that settles in the frame, and a throttled scroll read as the
       backstop. mark() ignores a repeat, so a double call costs nothing. */
    function fromScroll(){
      var w=frame.clientWidth||1;
      mark(Math.max(0,Math.min(imgs.length-1,Math.round(frame.scrollLeft/w))));
    }
    if(window.IntersectionObserver){
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){if(e.isIntersecting) mark(+e.target.getAttribute('data-gi'))});
      },{root:frame,threshold:.6});
      Array.prototype.forEach.call(imgs,function(im){io.observe(im)});
    }
    var tm=null;
    frame.addEventListener('scroll',function(){
      if(tm) return;
      tm=setTimeout(function(){tm=null;fromScroll()},110);
    },{passive:true});
    Array.prototype.forEach.call(thumbs,function(b){
      b.addEventListener('click',function(){
        var n=+b.getAttribute('data-gt');
        /* Chrome pulls a programmatic scroll straight back to the current
           snap point, so snapping comes off for the jump and goes back after. */
        frame.style.scrollSnapType='none';
        frame.scrollLeft=n*frame.clientWidth;
        frame.style.scrollSnapType='';
        mark(n)})});
    mark(0);
  });
}

/* the ingredients pop-up. Keeps her on the page instead of sending her away. */
function wireIngredients(){
  Array.prototype.forEach.call(document.querySelectorAll('[data-ing]'),function(b){
    b.addEventListener('click',function(){
      var n=b.getAttribute('data-ing');
      var it=allItems().filter(function(x){return x.name===n})[0];
      if(!it) return;
      $('mTitle').textContent=it.title; $('mFn').textContent=it.fn;
      $('mList').textContent=it.full;
      $('mNote').textContent=it.howto;
      $('modal').classList.add('on'); document.body.style.overflow='hidden'})});
}
function closeModal(){$('modal').classList.remove('on');document.body.style.overflow=''}
$('mClose').addEventListener('click',closeModal);
$('mScrim').addEventListener('click',closeModal);
document.addEventListener('keydown',function(e){if(e.key==='Escape')closeModal()});

function wscroll(dir){var w=$('wall');var c=w.querySelector('.wcard');
  if(c) w.scrollBy({left:dir*(c.offsetWidth+12),behavior:'smooth'})}
$('wprev').addEventListener('click',function(){wscroll(-1)});
$('wnext').addEventListener('click',function(){wscroll(1)});


/* The sticky bar stays hidden until she has read past the builder and reached
   the servings section. After that it is armed for good, so scrolling back up
   still shows it. Nothing competes with the ritual on the way down. */
var stickyArmed=false;
window.addEventListener('scroll',function(){
  if(!stickyArmed){
    var k=$('wallsec');
    if(k && k.getBoundingClientRect().top < window.innerHeight*0.75) stickyArmed=true;
  }
  $('sticky').classList.toggle('on',stickyArmed);
},{passive:true});

var start=(function(){var q=new URLSearchParams(location.search);
  return {key:q.get('result')||(window.LC_RESULT&&window.LC_RESULT.key)||M.results[0].key,name:q.get('name')||''}})();
render(start.key,start.name);
})();
